import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {HeadingSmall} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@repo/shared-styles";

import AppBadge from "./app-badge.tsx";

type Props = Record<any, any>;

export default class Downloads extends React.Component<Props> {
    render(): React.ReactNode {
        const badges = {
            Apple: (
                <AppBadge
                    storeName="Apple"
                    altText={t`Download Khan Kids from the Apple App Store`}
                    imageUrl="/images/kids/apple-app-store.svg"
                    safeStoreUrl="https://itunes.apple.com/app/apple-store/id1378467217?pt=698519&ct=landingpage&mt=8"
                />
            ),
            Google: (
                <AppBadge
                    storeName="Google"
                    altText={t`Download Khan Kids from Google Play`}
                    imageUrl="/images/kids/google-play-store.svg"
                    safeStoreUrl="https://play.google.com/store/apps/details?id=org.khankids.android&referrer=utm_source%3Dwebsite%26utm_medium%3Dlandingpage%26utm_campaign%3Dkhankidslandingpage"
                />
            ),
            Amazon: (
                <AppBadge
                    storeName="Amazon"
                    altText={t`Download Khan Kids from Amazon`}
                    imageUrl="/images/kids/amazon-appstore.svg"
                    safeStoreUrl="http://www.amazon.com/gp/mas/dl/android?p=org.khankids.android"
                />
            ),
        } as const;

        return (
            <View style={styles.container}>
                <HeadingSmall tag="h2" style={styles.headingSmall}>
                    {t`Download the app!`}
                </HeadingSmall>
                <View style={styles.options}>
                    {badges.Apple}
                    {badges.Google}
                    {badges.Amazon}
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        alignItems: "flex-start",

        [mediaQueries.mdOrSmaller]: {
            alignItems: "center",
        },
    },

    headingSmall: {
        fontSize: 32,
        fontWeight: "bold",
        marginBottom: 24,
        lineHeight: 0.97,

        [mediaQueries.smOrSmaller]: {
            marginBottom: 2,
            fontSize: 24,
            lineHeight: 2.38,
            textAlign: "center",
        },
    },

    options: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",

        [mediaQueries.mdOrSmaller]: {
            justifyContent: "center",
            alignItems: "center",
        },
    },
});
